
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { GoogleAdWordsLinkedService } from 'app/model/linkedservice/google-adwords.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.googleAdWords.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.GoogleAdWords_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.GoogleAdWords_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: GoogleAdWordsLinkedService.MODEL // Linked service redefined
        }
    }
})
export class GoogleAdWordsObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
